(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      $(".product-block-options__item").on("click", function(e){
    e.preventDefault()
    try {
      const $target=$(this)
      const productData=$target.parents("product-block").data("product-json")
      const color=$target.data("option-item")
      const idMedia=$target.data("media")
      const $allImage= $target.parents(".block-inner-inner").find(`.product-block__image`)
      const $image= $target.parents(".block-inner-inner").find(`.product-block__image[data-media-id="${idMedia}"`).eq(0)
      $allImage.removeClass("is-actived")
      $image.addClass("is-actived")
      const $productLink= $target.parents("product-block").find(".product-link")
      let linkOriginal= $productLink.eq(0).attr("href")
      if(linkOriginal.split("?").length){
        linkOriginal=linkOriginal.split("?")[0]
      }
      const variantIsActived= productData.filter((item)=>{
        return item.split("-")[1] == color
      })
      const variantId=variantIsActived[0].split("-")[0]
      if(variantId && linkOriginal ){
        $productLink.attr("href",`${linkOriginal}?variant=${variantId}`)
      }
    } catch (error) {
      console.log("error",error)
    }
})
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
